import { render, staticRenderFns } from "./ListOrganizer.vue?vue&type=template&id=487ae3a2&scoped=true&"
import script from "./ListOrganizer.vue?vue&type=script&lang=js&"
export * from "./ListOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./ListOrganizer.vue?vue&type=style&index=0&id=487ae3a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ae3a2",
  null
  
)

component.options.__file = "ListOrganizer.vue"
export default component.exports